const asset_base_path = process.env.REACT_APP_ASSET_BASE_PATH
const environment = process.env.REACT_APP_ENVIRONMENT
const folder_path = process.env.REACT_APP_ASSET_FOLDER_NAME

const base_path = asset_base_path + '/' + environment + '/' + folder_path + '/'
const image_config = '?auto=compress&'

export const IMAGE_SRC = {
	BSECURE_FAVICON: `${base_path}assets/images/logo/bsecure_favicon.png${image_config}`,
	BSECURE_WHITE_LOGO: `${base_path}assets/images/logo/bSecure_white_logo.png${image_config}`,
	BSECURE_DEFAULT_LOGO: `${base_path}assets/images/logo/default-bsecure-logo.png${image_config}`,

	BSECURE_SPINNER: `${base_path}assets/images/spinners/white.gif${image_config}`,
	BSECURE_BLUE_SPINNER: `${base_path}assets/images/spinners/blue.gif${image_config}`,
	MBL_BACK_ARROW: `${base_path}assets/images/icons/mobile-back.svg`,

	CAT_BANNER_IMG: `${base_path}assets/images/cat-banner.png${image_config}`,
	FOOTER_LOGO: `${base_path}assets/images/market-app-footer-logo.svg`,

	ABOUT_HEADER: `${base_path}assets/images/headers/about.png${image_config}`,
	ABOUT_STORE: `${base_path}assets/images/headers/store_image.png${image_config}`,
	PRIVACY_HEADER_IMG: `${base_path}assets/images/headers/privacy.png${image_config}`,
	UNDER_CONSTRUCTION: `${base_path}assets/images/under_construction.png${image_config}`,
}
